import { Path, Rect, Svg } from '@react-pdf/renderer';

export const ZRMLogo: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = () => {
  return (
    <Svg width="150" height="30" viewBox="0 0 1911 400">
      <Rect fill="#006bff" x="936.81" y="19.92" width="78.71" height="372.21" />
      <Rect fill="#006bff" x="1073.84" y="19.91" width="78.72" height="372.21" />
      <Path
        fill="#006bff"
        d="M1380.68,271.18c0-36.24-25.85-60.9-56.46-60.9-31.34,0-57.19,24.66-57.19,60.9,0,36.48,25.85,60.9,57.19,60.9,30.61,0,56.46-24.42,56.46-60.9m-189.16,0c0-74,59.68-128.81,132.7-128.81,72.29,0,132,54.84,132,128.81,0,74.21-59.68,129.05-132,129.05-73,0-132.7-54.84-132.7-129"
      />
      <Path
        fill="#006bff"
        d="M481.46,54.36v71.76H620.58c.57,0,.78.52.49,1L481.4,364.48c-3.36,6.17-4.16,7.49-4.16,13.65v14h271V320.49H597.69a.62.62,0,0,1-.5-1L738.48,79c1.12-2.34,2.3-4,2.3-9.64l.05-15Z"
      />
      <Path
        fill="#006bff"
        d="M798.37,148.58h78.7V392.13h-78.7Zm39.35-122c24.54,0,44.82,19.8,44.82,44.19S862.26,115,837.72,115s-44.81-19.8-44.81-44.2S813.18,26.6,837.72,26.6"
      />
      <Path
        fill="#006bff"
        d="M242.17,106.29c1.8-.44,2.63.2,3.71,1.41,6.16,6.93,26,31.1,31.4,37.71a2.12,2.12,0,0,1-.49,3.16c-40,31.22-84.49,75.38-109.3,107-.53.67-.09.72.26.57,43.21-18.6,144.67-48.27,190.44-56.59V141.64L179.28.23.05,141.64v63.29C55.61,171.91,184,120.8,242.17,106.29Z"
      />
      <Path
        fill="#006bff"
        d="M96.63,349.5a3,3,0,0,1-3.88-.57L59.34,309.14c-.93-1.08-1-1.65.18-3.41C85.32,267.88,138,209,171.59,184.05c.6-.44.44-.86-.26-.63-35,11.44-134.47,54.17-171.28,75V393.6H358.18V263.5C309.27,271.81,163.08,315.27,96.63,349.5Z"
      />
      <Path
        fill="#006bff"
        d="M1895.2,113.87c0-7-4.86-11.91-11.67-11.91H1871v34h5.59V125.77h5.49L1888.3,136h6.36l-6.7-11C1892.33,123.34,1895.2,119.16,1895.2,113.87Zm-12,6.9h-6.61V107h6.61c3.7,0,6.42,2.92,6.42,6.91S1886.89,120.77,1883.19,120.77Z"
      />
      <Path
        fill="#006bff"
        d="M1881.84,90.16a29.38,29.38,0,1,0,29.38,29.37A29.41,29.41,0,0,0,1881.84,90.16Zm0,53.11a23.74,23.74,0,1,1,23.74-23.74A23.77,23.77,0,0,1,1881.84,143.27Z"
      />
      <Path
        fill="#006bff"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M 1460.41 148.57 h 77.77 l 22.54 73.68 l 20.09 70.24 a 0.6 0.6 0 0 0 1.13 0 L 1626 148.57 h 57.44 l 23.23 73.68 l 20 70.22 a 0.6 0.6 0 0 0 1.15 0 l 20.07 -70.22 l 22.55 -73.68 h 72.28 l -78.19 243.55 h -71.13 L 1674 331 c -7.45 -24 -20.55 -70.57 -20.55 -70.57 a 0.6 0.6 0 0 0 -1.15 0 l -20.95 70.15 l -19.77 61.59 h -72.41 Z"
      />
    </Svg>
  );
};
